import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Card,
    CardBody,
    Button,
    CustomInput
} from 'reactstrap';
import Switch from 'rc-switch';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_Update_HideStats } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';

export default function HideStats({ propertyId, property }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [hideStatData, setHideStatsData] = useState({
        hideWebWidget: false
    });
    useEffect(() => {
        if (property !== undefined && property.hideStats !== null) {
            setHideStatsData({
                hideWebWidget: property.hideStats.hideWebWidget
            });
        }
    }, [property]);

    const handleChange = (e) => {
        console.log();
        setHideStatsData({
            ...hideStatData,
            hideWebWidget: e.target.checked
        });
    }
    const handleSave = () => {
        var body = {
            hideStats: hideStatData,
            updater: "Admin"
        }
        console.log(44, body);
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_HideStats}/${propertyId}`,
            data: body,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                NotificationManager.success(
                    "",
                    "hide stats updated successfully",
                    3000,
                    null,
                    null,
                    "success"
                );
            }
        });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <div className="text-center">
                        <h6>Data Insights</h6>
                        <Separator className="mb-3" />
                    </div>
                    <Row className="">
                        <Colxx md={12} className='mt-2'>
                            <div className='align-vertical-center'>
                                <CustomInput
                                    key="hideWebWidget"
                                    type="checkbox"
                                    checked={hideStatData.hideWebWidget}
                                    onChange={(e) => handleChange(e)}
                                ><span>Hide Web Widget Stats</span></CustomInput>
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <div className="mb-1 mt-4 ml-2 text-center">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={() => handleSave()}
                                >
                                    Save
                                </Button>
                            </div>
                        </Colxx>
                    </Row>
                </CardBody>
            </Card>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>

    )
}